import React, { useState } from 'react';
import { Col, Row } from 'antd';
import '@ant-design/compatible/assets/index.css';
import "@iso/containers/PDV/styles/pdvStyles.css"

export default function Cliente(props) {

    return (
        <Row gutter={24}>
            <Col span={24} className='contentItemEditInputs text-right' style={{fontSize:'16px', textAlign:'right'}}>Cliente: {(props?.currentOrder?.client !== null) ? ((props?.currentOrder?.client?.name !== '') 
                ? props?.currentOrder?.client?.name : props?.currentOrder?.client?.cpf_cnpj) : 'CONSUMIDOR FINAL'}</Col>
        </Row>
    )
}